const pages = require("./../../../src/../src-dynamic/destination.pages");
const { getSlug, getCommerceSlug } = require("./../../@modules/utils.slugs");
const { translate } = require("./../../@modules/utils.language");

/**
 * Get CTA Button label
 *
 * @param {TCTAButton} call_to_action
 * @param {string} language
 * @param {string} defaultLanguage
 * @returns
 */
module.exports.getLabelForCTAButton = function getLabelForCTAButton(call_to_action, language, defaultLanguage) {
    let buttonText = undefined;
    if (call_to_action.cta_link_type === 'entry' || call_to_action.cta_link_type === 'package' || call_to_action.cta_link_type === 'product' || call_to_action.cta_link_type === 'supplier' || call_to_action.cta_link_type === 'internal' || call_to_action.cta_link_type === 'action') {
        buttonText = translate(call_to_action.translations, language, 'cta_button_label');
    } else if (call_to_action.cta_link_type === 'external') {
        buttonText = translate(call_to_action.link_translations, language, 'cta_button_label');
    }

    return buttonText;
}

/**
 * Returns CTA Button link
 * @param {TCTAButton} call_to_action
 * @param {string} language
 * @param {string} defaultLanguage
 * @returns
 */
module.exports.getLinkForCTAButton = function getLinkForCTAButton(call_to_action, language, defaultLanguage) {
    // const notFoundPage = pages.not_found_page;

    let buttonLink = undefined;

    if (call_to_action.cta_link_type === 'internal' || call_to_action.cta_link_type === 'package' || call_to_action.cta_link_type === 'product' || call_to_action.cta_link_type === 'supplier') {
        const removeFinalSlash = new RegExp(/\/+$/g);
        if (call_to_action.cta_link_type === 'product' || call_to_action.cta_link_type === 'supplier') {
            const linkedItem = call_to_action[`cta_button_linked_${call_to_action.cta_link_type}`];
            buttonLink = getCommerceSlug(
                language, 
                defaultLanguage, 
                linkedItem?.translations || [], 
                "slug",
                linkedItem?.type
            )?.replace(removeFinalSlash, '/');
        } else {
            buttonLink = getSlug(language, defaultLanguage, call_to_action[`cta_button_linked_${call_to_action.cta_link_type === "internal" ? "page" : call_to_action.cta_link_type}`]?.translations || [])?.replace(removeFinalSlash, '/');
            if (call_to_action.cta_link_type === 'package' && call_to_action.cta_button_linked_package?.integration_uuid) {
                buttonLink = buttonLink + `/${call_to_action.cta_button_linked_package.integration_uuid}`;
            }
        }
        /*const removeSlashesAndLanguage = new RegExp(`^\\/(${language})\\/|\\/\\/+`, 'g');
        const noSlug = buttonLink.replace(removeSlashesAndLanguage, '') === "";
        if (noSlug && notFoundPage) {
            buttonLink = translate(notFoundPage, language, "slug");
        }*/
    } else if (call_to_action.cta_link_type === 'entry') {
        buttonLink = getSlug(language, defaultLanguage, call_to_action.cta_button_linked_entry?.translations || []);
    } else if (call_to_action.cta_link_type === 'external') {
        buttonLink = translate(call_to_action.link_translations, language, 'cta_button_link');
    }

    return buttonLink;
}